module.exports = __webpack_public_path__ + "img/Frame 5131.7f4178cc.jpg";